import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function SvgComponent(props) {
	return (
		<Svg
			width={props.size}
			height={props.size}
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<Path
				d='M22 5.5v13c0 .4-.15.75-.45 1.05-.3.3-.65.45-1.05.45h-17c-.4 0-.75-.15-1.05-.45-.3-.3-.45-.65-.45-1.05v-13c0-.4.15-.75.45-1.05.3-.3.65-.45 1.05-.45h17c.4 0 .75.15 1.05.45.3.3.45.65.45 1.05zM3.5 8.225h17V5.5h-17v2.725zm0 3.225v7.05h17v-7.05h-17zm0 7.05v-13 13z'
				fill={props.color || '#1434CB'}
			/>
		</Svg>
	);
}

export default SvgComponent;
